import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/appreciations', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const store = data => {
  return httpClient
    .post('/api/appreciations', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const certificateAppreciation = (options = {}) => {
  return httpClient
    .get('/api/appreciations/certificate-appreciations', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const studentCertificate = (options = {}) => {
  return httpClient
    .get('/api/appreciations/student-certificates', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const printPdf = id => {
  return httpClient
    .get(`/api/appreciations/print-pdf/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  get,
  certificateAppreciation,
  studentCertificate,
  store,
  printPdf
}
